import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
} from '@angular/core';
import { TextSize } from '@freelancer/ui/text';
import { IconColor } from '../icon';
import {
  LinkColor,
  LinkHoverColor,
  LinkIconPosition,
  LinkWeight,
} from '../link';
import { SectionHomepageEntryLinkComponent } from './section-homepage-entry-link.component';
import { LinkModule } from '../link/link.module';

@Component({
  standalone: true,
  imports: [LinkModule],
  selector: 'fl-section-homepage-entry',
  template: `
    <div class="mb-mid tablet:mb-large desktop_large:mb-xlarge">
      <h3
        class="text-light text-mid desktop:text-xlarge mb-xxxsmall tablet:mb-xxsmall desktop:mb-xsmall"
      >
        <ng-content select="fl-section-homepage-entry-heading"></ng-content>
      </h3>
      <p
        class="text-light text-xsmall desktop:text-mid {{
          sectionHomepageEntryLinkComponent ? 'mb-xsmall' : 'mb-none'
        }} {{
          sectionHomepageEntryLinkComponent
            ? 'tablet:mb-small'
            : 'tablet:mb-none'
        }}"
      >
        <ng-content select="fl-section-homepage-entry-description"></ng-content>
      </p>
      @if (sectionHomepageEntryLinkComponent) {
        <fl-link
          flTrackingLabel="flTrackingLabel"
          [color]="LinkColor.PRIMARY"
          [iconColor]="IconColor.PRIMARY"
          [iconName]="'ui-arrow-right'"
          [iconPosition]="LinkIconPosition.RIGHT"
          [hoverColor]="LinkHoverColor.PRIMARY"
          [link]="link"
          [size]="TextSize.MARKETING_SMALL"
          [weight]="LinkWeight.BOLD"
        >
          <ng-content select="fl-section-homepage-entry-link"></ng-content>
        </fl-link>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHomepageEntryComponent {
  IconColor = IconColor;
  LinkColor = LinkColor;
  LinkIconPosition = LinkIconPosition;
  LinkHoverColor = LinkHoverColor;
  LinkWeight = LinkWeight;
  TextSize = TextSize;

  @Input() flTrackingLabel: string;
  @Input() link: string;

  @ContentChild(SectionHomepageEntryLinkComponent)
  sectionHomepageEntryLinkComponent: SectionHomepageEntryLinkComponent;
}
